

<script>
/* eslint-disable no-console */
export default {
  props: ["setTime"],
  data() {
    return {
      timer: {},

      limitTime: null,
      limit: false,

      stopper: false
    };
  },
  mounted() {
    this.limitTime = this.config.limitTime;
    if (this.sent) {
      this.limitTime = 0;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    start() {
      if (!this.modal) {
        this.timer = setTimeout(this.tick, 1000);
      }
    },
    pause() {
      console.log("stopper true");
      this.stopper = true;
      console.log(this.stopper);
    },
    resume() {
      this.stopper = false;
    },
    tick() {
      if (!this.sent) {
        if (this.config.limit) {
          if (this.limitTime <= 1) {
            if (!this.stopper) {
              if (!this.sent) {
                this.$emit("timeover");
                this.limitTime -= 1;
              }
            } else {
              this.$nextTick(() => {
                this.start();
              });
            }
          }
          if (this.now < this.list.length && this.limitTime > 0) {
            if (!this.stopper) {
              this.limitTime -= 1;
            }
            this.$nextTick(() => {
              this.start();
            });
          }
          this.$emit("timer", this.limitTime);
          console.log("timer", this.limitTime, this.stopper);
        }
      }
    }
  },
  computed: {
    sent() {
      return this.$store.getters.sent || this.$store.state.mode === "end";
    },
    config() {
      return this.$store.state.config;
    },
    list() {
      return this.$store.getters.list;
    },
    now() {
      return this.$store.state.questionId;
    }
  }
};
</script>